import request from "../../services/HTTPClient";
import { requestMethods, API } from "../../constants";

function buildQuery(params = {}) {
  const { start_date, end_date, month, year } = params;
  const q = [];
  if (start_date) q.push(`start_date=${start_date}`);
  if (end_date) q.push(`end_date=${end_date}`);
  if (month) q.push(`month=${month}`);
  if (year) q.push(`year=${year}`);
  return q.length ? `?${q.join('&')}` : '';
}

function getIndicators(params = {}) {
  return request({
    url: `${API.FINANCIAL_DASHBOARD.INDICATORS}${buildQuery(params)}`,
    method: requestMethods.GET,
  });
}

function getSummary(params = {}) {
  return request({
    url: `${API.FINANCIAL_DASHBOARD.SUMMARY}${buildQuery(params)}`,
    method: requestMethods.GET,
  });
}

function getAccounts(params = {}) {
  return request({
    url: `${API.FINANCIAL_DASHBOARD.ACCOUNTS}${buildQuery(params)}`,
    method: requestMethods.GET,
  });
}

function getExpensesReport(params = {}) {
  return request({
    url: `${API.FINANCIAL_DASHBOARD.EXPENSES_REPORT}${buildQuery(params)}`,
    method: requestMethods.GET,
  });
}

function getCalendar(month, year) {
  return request({
    url: `${API.FINANCIAL_DASHBOARD.CALENDAR}?month=${month}&year=${year}`,
    method: requestMethods.GET,
  });
}

function getCalendarDay(date) {
  return request({
    url: `${API.FINANCIAL_DASHBOARD.CALENDAR_DAY}?date=${date}`,
    method: requestMethods.GET,
  });
}

function getAllFinancialData(params = {}) {
  return Promise.all([
    getIndicators(params).catch(() => ({ data: {} })),
    getSummary(params).catch(() => ({ data: {} })),
    getAccounts(params).catch(() => ({ data: {} })),
    getExpensesReport(params).catch(() => ({ data: {} })),
  ]).then(([indicatorsRes, summaryRes, accountsRes, expensesReportRes]) => ({
    indicators: indicatorsRes?.data || {},
    summary: summaryRes?.data || {},
    accounts: accountsRes?.data || {},
    expensesReport: expensesReportRes?.data || {},
  }));
}

const FinancialDashboardService = {
  getIndicators,
  getSummary,
  getAccounts,
  getExpensesReport,
  getCalendar,
  getCalendarDay,
  getAllFinancialData,
};

export default FinancialDashboardService;
